var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { BodyText } from '../BodyText';
import { Tooltip } from '../Tooltip';
import { Icon } from '../Icon';
import { Stack } from '../Stack';
import classNames from 'classnames';
export const MoreDetails = React.forwardRef((_a, ref) => {
    var { full, short, direction = 't', className, labelClassName, iconClassName, tooltipProps, size } = _a, props = __rest(_a, ["full", "short", "direction", "className", "labelClassName", "iconClassName", "tooltipProps", "size"]);
    const MoreDetailsIconClassNames = classNames('MoreDetailsIcon', iconClassName, {
        [`MoreDetailsIcon--${size}`]: size,
    });
    const MoreDetailsClassNames = classNames('d-if', className);
    return (React.createElement(Stack, Object.assign({ alignItems: "center", className: MoreDetailsClassNames, ref: ref, "data-anvil-component": "MoreDetails" }, props),
        React.createElement(BodyText, { size: size, className: labelClassName }, short),
        short !== full && (React.createElement(Tooltip, Object.assign({ text: full, className: "lh-1", portal: true, direction: direction }, tooltipProps),
            React.createElement("div", { className: MoreDetailsIconClassNames },
                React.createElement(Icon, { name: "more_horiz" }))))));
});
//# sourceMappingURL=MoreDetails.js.map